import { render, staticRenderFns } from "./LayerSnf.vue?vue&type=template&id=4f5114fc&"
import script from "./LayerSnf.vue?vue&type=script&lang=js&"
export * from "./LayerSnf.vue?vue&type=script&lang=js&"
import style0 from "./LayerSnf.vue?vue&type=style&index=0&id=4f5114fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports